'use client';

import { QueryKeys } from '@/constants/query-keys';
import { storeCreditApiService } from '@/services/(frontend)/profile/store-credit-api.service';
import { CinemarkCashResponse } from '@/types/cinemark-cash';
import { useQuery } from '@tanstack/react-query';
import { useDynamicStaleTime } from '../shared/dynamic-stale-time';
import { useIsAuthReady } from './is-auth-ready';

export const useStoreCredits = (): ReturnType<typeof useQuery<CinemarkCashResponse>> => {
  const updateQueryStaleTime = useDynamicStaleTime();
  const { isAuthenticated } = useIsAuthReady();

  return useQuery<CinemarkCashResponse>({
    enabled: isAuthenticated,
    queryFn: async () => {
      const response = await storeCreditApiService.getStoreCredits();

      if (response.headers) {
        updateQueryStaleTime(QueryKeys.user.storeCredits, response.headers);
      }

      const totalCash = response.data?.data?.reduce((value, item) => value + item.balance, 0) || 0;
      return { data: response.data, totalCash };
    },
    queryKey: QueryKeys.user.storeCredits,
  });
};
